<template>
    <footer>
		  <div class="left">
			<img class="erweima" src="../../assets/erweima.png" alt="">
		  </div>
		  <div class="right">
			<van-button class="ios" type="default" @click="iosDownload">iOS下载</van-button>
			<van-button class="and" type="default" @click="andDownload">Android下载</van-button>
		  </div>
		</footer>
</template>

<script>
  export default {
    props: {
      title: String
    },
    methods:{
			andDownload(){
				window.location.href = 'https://webcdn.m.qq.com/webapp/homepage/index.html#/appDetail?apkName=com.zjjt.zjjy&info=EA42843E0B69DA6449094485B3F9684B'
			},
			iosDownload(){
				window.location.href = 'https://apps.apple.com/cn/app/%E4%B8%AD%E5%BB%BA%E6%95%99%E8%82%B2-%E5%9C%A8%E7%BA%BF%E8%81%8C%E4%B8%9A%E8%80%83%E8%AF%81%E5%B9%B3%E5%8F%B0/id1592962168'
			}
		}
  }
</script>

<style>
  footer{
	  position: absolute;
	  left: 0;
	  bottom: 0;
	  width: 100%;
	  height: 173px;
	  background-color: white;
	  display: flex;
	}
	.left{
	  width: 50%;
	   height: 173px;
	}
	.erweima{
	  width: 113px;
	  height: 113px;
	  position: absolute;
	  left: 57px;
	  top: 30px;
	}
	.right{
	    width: 50%;
	    height: 173px;
	}
	.ios{
	  padding: 0 15px;
	    font-size: 14px;
	    position: absolute;
	    top: 44px;
	    width: 130px;
	    height: 34px;
	}
	.and{
	    padding: 0 15px;
	    font-size: 14px;
	    position: absolute;
	    top: 94px;
	    width: 130px;
	    height: 34px;
	}
	.van-button--default {
	    color: #323233;
	    background-color: #fff;
	    border: 1px solid #323232;
	    border-radius: 5px;
	}
</style>
